<template>
  <div class="footer">
    <div class="footer_box pcmain">
      <div class="pc_footer">
        <!-- <div class="  footer_logo_bar">
     <img  v-lazy="site.footer_logo_path" style=" " :data-src="site.footer_logo_path"    :alt="site.name" height="67px" />
</div> -->
        <div class="footer_contact_tel_bar">
          <div class="tel">
            <a :href="`tel:${site.mobile}`">{{ site.mobile }}</a>
          </div>
        </div>
        <div class="pc_navigation_footer">
          <ul>
            <li v-for="(item, index) in navigation_lists_footer" :key="index">
              <!--           <div class="nav"> -->
              <a :href="item.url" :target="item.target">{{ item.name }}</a>
              <!--               </div> -->
              <!--
            <ol v-if="item.sub_lists.length > 0">
                <li v-for="(sub_item,sub_index) in item.sub_lists" :key="sub_index" >
                    <a :href="sub_item.url" :target="sub_item.target" >{{sub_item.name}}</a>
                </li>
           </ol>
           -->
            </li>
          </ul>
        </div>

        <div class="qrcode_bar" v-if="site.qrcode_logo_path">
          <p>
            <img
              v-lazy="site.qrcode_logo_path"
              :data-src="site.qrcode_logo_path"
              :alt="site.name"
              height="67px"
            />
          </p>
          <p>访问手机版</p>
        </div>

        <!-- <div class="qrcode_bar" v-if="site.official_account_logo_path">
          <p>
            <img
              v-lazy="site.official_account_logo_path"
              :data-src="site.official_account_logo_path"
              :alt="site.name"
              height="67px"
            />
          </p>
          <p>微信公众号</p>
        </div> -->
      </div>

      <!--                <div class="address"> 地址：{{site.address}}</div>
                <div class="fax">传真：{{site.fax}} </div>
                <div class="email"> 邮箱：{{site.email}}</div> -->

      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
// import vCopyright from '@/components/page/tmp/Copyright.vue';
import vSupported from "@/components/common/supported.vue";

// import bus from '@/components/common/bus';

import Storage from "@/components/libs/storage";
import Site from "@/components/model/site/site";

import Navigation from "@/components/model/navigation/navigation";

export default {
  data() {
    return {
      SITE_NAME: SITE_NAME + " - 后台管理系统 ",
      collapse: false,
      fullscreen: false,
      name: "外星人来了",
      message: 2,
      // site:{
      //     'logo':require('@/assets/logo.png'),
      //     'tel':'',
      //     'tel_icon':require('@/assets/images/footer_tel_slices/tel.png'),
      //     "address":'',
      //     "fax":'',
      //     "email":'',
      // },
      // navigation_lists_footer:[
      //         {
      //                 "url" :'/',
      //                 "target":'_self',
      //                 'name': '首页',
      //                 'sub_lists':  [],
      //         },

      //         {
      //                 "url" :'/',
      //                 "target":'_self',
      //                 'name': '新闻中心',
      //                 'sub_lists':  [],
      //         },

      // ],
    };
  },

  components: {
    // vCopyright,
    //           vSupported
  },
  computed: {
    username() {
      const that = this;
      return "";
    },
  },
  // navigation_lists_footer
  props: ["navigation_lists_footer", "site"],

  created() {
    const that = this;
    // that.get_site();
    ///that.get_navigation_footer_lists();
  },

  mounted() {
    const that = this;
    // 底部导航 footer_lists
  },

  methods: {
    //  // 底部导航 footer_lists
    //sessionStorage - 针对一个 session 的数据存储
    get_navigation_footer_lists66666666666666666666666666666666666() {
      const that = this;
      if (
        Storage.s_getItem("navigation_lists_footer") &&
        Storage.s_getItem("navigation_lists_footer") !== "" &&
        Storage.s_getItem("navigation_lists_footer").length > 0
      ) {
        that.navigation_lists_footer = Storage.s_getItem(
          "navigation_lists_footer"
        );

        that.navigation_lists_footer.sort(function (a, b) {
          ///return x.sort – y.sort;
          //  return a['sort'] > b['sort'] ;
          return b["sort"] - a["sort"];
        });
      } else {
        Navigation.footer_lists({})
          .then((res) => {
            if (res.status == 1) {
              that.navigation_lists_footer.length = 0;
              let list = [];
              let l;

              res.data.result.sort(function (a, b) {
                ///return x.sort – y.sort;
                // return a['sort'] > b['sort'] ;
                return b["sort"] - a["sort"];
              });

              res.data.result.forEach((item, index) => {
                if (item.parent_id === 0) {
                  l = {
                    url: item.url,
                    target: "_self",
                    name: item.name,
                    sort: item.sort,
                    sub_lists: [],
                  };
                  res.data.result.forEach((sub_item, sub_index) => {
                    if (item.id === sub_item.parent_id) {
                      l.sub_lists.push({
                        url: sub_item.url,
                        sort: sub_item.sort,
                        target: "_self",
                        name: sub_item.name,
                      });
                    }
                  });
                  list.push(l);
                }
              });
              that.navigation_lists_footer = list;
              Storage.s_setItem("navigation_lists_footer", list);
            } else {
            }
          })
          .catch((res) => {
            console.info("底部导航", res);
          });
      }
    },

    get_site555555555555555555555555() {
      const that = this;
      if (Storage.s_getItem("site") && Storage.s_getItem("site") !== "") {
        let _site = Storage.s_getItem("site");
        that.site.tel = _site.mobile;
        that.site.address = _site.address;
        that.site.fax = _site.fax;
        that.site.email = _site.email;
        if (_site.logo) {
          that.site.logo = _site.logo;
        }
        console.log("Site ok  pcFooter.vue");
      } else {
        console.log("Site err112  pcFooter.vue");
        Site.info({})
          .then((res) => {
            if (res.status == 1) {
              Storage.s_setItem("site", res.data.result);
              // that.get_site();
              let _site = res.data.result;
              that.site.tel = _site.mobile;
              that.site.address = _site.address;
              that.site.fax = _site.fax;
              that.site.email = _site.email;
              if (_site.logo) {
                that.site.logo = _site.logo;
              }
            }
          })
          .catch((res) => {
            console.info("Site.info", res);
          });
      }
    },
  },
  mounted() {
    // if(document.body.clientWidth < 1500){
    //  //   this.collapseChage();
    // }
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/tmp/pcFooter.vue